import { Component,Input, OnInit } from '@angular/core';
import { BrowseConfig } from '@core/bean/browse-config';
import { Pagination } from '@core/bean/pagination';
import { environment } from '@env/environment';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonsService } from '@core/service/commons.service';
import { NzModalService } from 'ng-zorro-antd';
import {CompactMatService} from "../../../../routes/jy-srm/contract-order-execute/compact/compact-mat.service";
import {CompactService} from "../../../../routes/jy-srm/contract-order-execute/compact/compact.service";
import {Sort} from "@core/bean/sort";
import {Direction} from "@core/bean/direction";

@Component({
  selector: 'app-compact.browse',
  templateUrl: './compact.browse.component.html',
  styles: []
})
export class CompactBrowseComponent implements OnInit {


  static componentName = 'CompactBrowseComponent';

  @Input() config:BrowseConfig;
  @Input() onOk:(data:any | [any]) => void;
  @Input() onCancel:() => void;

  visible = false;
  formLoading = false;
  pagination:Pagination = new Pagination();
  searchData:any = {};
  headUrl = environment.SERVER_URL.substr(0, environment.SERVER_URL.length - 1);

  constructor(private commonsService:CommonsService,
              private modalService:NzModalService,
              private compactService:CompactService,
              private compactMatService:CompactMatService
  ) {

    this.pagination.getData = function (params:HttpParams):Observable<any> {
      return compactService.query(params);
    }

  }

  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    this.getData();
    this.visible = true;
  }


  getData() {
    this.pagination.searchData = this.searchData;
    // 浏览框架添加排序规则
    this.pagination.addSort(new Sort('compactCode',Direction.DESC));
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  selectData(data){
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }


}
